import Card from '../../../Common/Card'
import styles from './CloneNotes.css'

const COPYABLE_ITEMS = [
  '賣場/商品名稱',
  '品牌',
  '規格表',
  '賣場詳情',
  '商品特色',
  '商品圖',
  '屬性項目資訊'
]

const CloneNotes = () => {
  return (
    <Card
      hasPadding
      hasShadow
    >
      <div className={styles.container}>
        <p className={styles.sectionTitle}>可複製內容與注意事項</p>
        <p className={styles.description}>使用「跨平台複製賣場」功能時，系統會依外部賣場可取得的資料，自動擷取並帶入提案內容，協助您快速建立賣場提案。</p>
        <p className={styles.sectionTitle}>可複製資料包含：</p>
        <ul className={styles.list}>
          {COPYABLE_ITEMS.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <p className={styles.sectionTitle}>注意事項：</p>
        <ul className={styles.list}>
          <li>
            商品圖片需符合平台規範，若來源圖片尺寸或比例不符，可能無法成功複製。
            <br />
            例如：平台商品主圖需為
            <strong>1000 x 1000 以上正方形圖片</strong>
            。
          </li>
          <li>規格表是否可成功複製，需視來源網站頁面結構而定；若結構差異較大，可能無法完整擷取。</li>
          <li>實際複製結果仍以來源網站可取得資料為準，部分欄位若未成功帶入，請再手動補充。</li>
        </ul>
      </div>
    </Card>
  )
}

export default CloneNotes
